import type { JSX } from 'react';
import { FullyGuardedPlayerPositionManager } from './FullyGuardedPlayerPositionManager';
import type { PlayerPositionManagerProps } from './PlayerPositionManager';

export type PartiallyGuardedPlayerPositionManagerProps<TPlayerParentContainer> = Pick<
  PlayerPositionManagerProps<TPlayerParentContainer>,
  | 'bottomStyleWhenStickyAtBottomRight'
  | 'leftStyleWhenStickyAtTop'
  | 'rightStyleWhenStickyAtBottomRight'
  | 'rightStyleWhenStickyAtTop'
  | 'topStyleWhenStickyAtTop'
  | 'widthStyleWhenStickyAtBottomRight'
> & {
  player: NonNullable<PlayerPositionManagerProps<TPlayerParentContainer>['player']>;
  playerParentContainer: NonNullable<
    PlayerPositionManagerProps<TPlayerParentContainer>['playerParentContainer']
  >;
  intersectionObserverTarget: HTMLDivElement | null;
  nonStickyPlayerPhantom: HTMLDivElement | null;
};

export const PartiallyGuardedPlayerPositionManager = <TPlayerParentContainer extends HTMLElement>({
  bottomStyleWhenStickyAtBottomRight,
  intersectionObserverTarget,
  nonStickyPlayerPhantom,
  player,
  playerParentContainer,
  rightStyleWhenStickyAtBottomRight,
  widthStyleWhenStickyAtBottomRight,
  leftStyleWhenStickyAtTop,
  rightStyleWhenStickyAtTop,
  topStyleWhenStickyAtTop,
}: PartiallyGuardedPlayerPositionManagerProps<TPlayerParentContainer>): JSX.Element | null => {
  if (intersectionObserverTarget == null || nonStickyPlayerPhantom == null) {
    return null;
  }

  return (
    <FullyGuardedPlayerPositionManager
      bottomStyleWhenStickyAtBottomRight={bottomStyleWhenStickyAtBottomRight}
      intersectionObserverTarget={intersectionObserverTarget}
      leftStyleWhenStickyAtTop={leftStyleWhenStickyAtTop}
      nonStickyPlayerPhantom={nonStickyPlayerPhantom}
      player={player}
      playerParentContainer={playerParentContainer}
      rightStyleWhenStickyAtBottomRight={rightStyleWhenStickyAtBottomRight}
      rightStyleWhenStickyAtTop={rightStyleWhenStickyAtTop}
      topStyleWhenStickyAtTop={topStyleWhenStickyAtTop}
      widthStyleWhenStickyAtBottomRight={widthStyleWhenStickyAtBottomRight}
    />
  );
};
